<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Attach resource') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>{{ _('Filter the search') }}</label>
            <input type="text" class="form-control" v-model="searchFilter" />
          </div>
        </div>
      </div>
      <div style="height: 350px; overflow-y: auto; overflow-x: hidden">
        <table class="table table-striped">
          <tbody>
            <tr v-for="resource in filteredResources" v-on:click="toggleResource(resource)">
              <td style="width: 50px">
                {{ resource.id }}
              </td>
              <td>
                <strong>{{ resource.name }}</strong><br /><small>{{ formatType(resource) }}</small>
              </td>
              <td style="width: 50px">
                <button type="button" :class="btnClass(resource)" v-on:click.stop="toggleResource(resource)"><i :class="'fa fa-fw fa-' + btnIcon(resource)"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="selectResource" :disabled="!canSelect"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import constants from '~/lib/constants'
import formatters from '~/lib/formatters'

export default {
  props: ['selectedResources'],
  mixins: [constants, formatters],
  data () {
    return {
      resource: null,
      resources: [],
      addResourceIds: [],
      searchFilter: ''
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'apiKey']),
    selectedResourceIds () {
      return this.selectedResources.map(l => l.id)
    },
    filteredResources () {
      if (!this.searchFilter) {
        return this.resources
      }
      return this.resources.filter(r => this.addResourceIds.includes(r.id) || String(r.id) === this.searchFilter || r.name.toLowerCase().includes(this.searchFilter.toLowerCase()))
    },
    canSelect () {
      return this.addResourceIds && this.addResourceIds.length
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    selectResource () {
      this.$emit('selectResources', this.resources.filter(r => this.addResourceIds.includes(r.id)))
    },
    async loadResources() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/resources.json?iSortingCols=1&iSortCol_0=1&sSortDir_0=asc&apikey=' + this.apiKey)
      } catch(e) {}
      this.resources = response.data.filter(resource => {
        return resource.displayedtype !== 'openinghours' && this.selectedResourceIds.indexOf(resource.id) === -1 // Only list resources that are not already added
      })
    },
    btnClass (resource) {
      if (this.addResourceIds.includes(resource.id)) {
        return 'btn btn-xs btn-success'
      }
      return 'btn btn-xs btn-default'
    },
    btnIcon (resource) {
      if (this.addResourceIds.includes(resource.id)) {
        return 'check-square'
      }
      return 'check-square-o'
    },
    toggleResource(resource) {
      if (this.addResourceIds.includes(resource.id)) {
        this.addResourceIds = this.addResourceIds.filter(id => id !== resource.id)
      } else {
        this.addResourceIds.push(resource.id)
      }
    },
    formatType(resource) {
      const cell = {
        getValue () {
          return resource.displayedtype
        }
      }
      return this.resourceTypeFormatter()(cell)
    }
  },
  mounted () {
    this.loadResources()
  }
}
</script>